module.exports = __webpack_public_path__ + "img/xuanchuan2.0805eb42.png";